module.exports = __webpack_public_path__ + "img/organ.8f14021d.jpg";